export default __webpack_public_path__ + "778ae66ef1f03e7531a48cc85d206277.png";